import { render, staticRenderFns } from "./activity-dreaming-support.vue?vue&type=template&id=61a2cbaa&scoped=true&"
import script from "./activity-dreaming-support.vue?vue&type=script&lang=js&"
export * from "./activity-dreaming-support.vue?vue&type=script&lang=js&"
import style0 from "./activity-dreaming-support.vue?vue&type=style&index=0&id=61a2cbaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2cbaa",
  null
  
)

export default component.exports